import TeacherExamPeriodAPI from '@/apis/business/teacher/teacher-exam-period-api.js'
import ExamStoreAPI from '@/apis/business/teacher/exam-store-api.js'
import Enumeration from '@/common/enumeration'
import StudentClasroomAPI from '@/apis/business/teacher/student-classroom-api.js'
import SchoolExamPeriodDetailAPI from '@/apis/business/teacher/school-exam-period-detail-api.js'
import SchoolExamAssignAPI from '@/apis/business/teacher/school-exam-assign-api.js'
import { Pagination } from '@/common/constant'

export default {
  namespaced: true,

  state: {
    viewActive: Enumeration.ExamStatus.MyPost,
    tabActive: Enumeration.ExamStatusFilter.NotDone,
    examPeriodDetail: {}, // thông tin bài kiểm tra
    listStudentExamPeriodFromApi: [], // Danh sách học sinh
    examPeriod: {},
    examStores: [], // List đề kiểm tra
    classRooms: [], // list danh sách lớp
    classroom: {},
    itemExam: null,
    listExams: [], // list bài kiểm tra
    studentClassrooms: [], // trai
    chooseStudentClassroom: [], // bảng tạm clone hs đã chọn
    selectedStudentClassroom: [], // phai
    updateStatusResponse: {}, // Thông tin thời gian trả về sau khi mở đóng đề
    listExamPeriodIdToSetTimeout: [], // Lưu danh sách các bài kiểm tra đã được set time out
    totalNotDoneTeacherExam: null,
    totalDoneTeacherExam: null,
    listExamPeriodOverview: [],
    shuffleExam: null, // Thông tin bài kiểm tra
    examCodes: [], // Danh sách mã đề
    studentAmountSubmit: 0
  },

  getters: {},

  mutations: {
    // SetExam
    // CreateBy: VHSon 11.08
    setExam (state, exam) {
      state.examPeriod = exam
      state.examPeriodDetail = exam
    },

    // setTabActive danh sách bài kiểm tra
    // CreateBy: VHSon 22.03
    setTabActive (state, data) {
      state.tabActive = data
    },

    setChooseStudentClassroom (state, chooseStudentClassroom) {
      state.chooseStudentClassroom = chooseStudentClassroom
    },

    /**
     * xét lại dữ liệu
     * CreateBy: Nvduc 19.08
     */
    setStudentClassrooms (state, studentClassrooms) {
      state.studentClassrooms = studentClassrooms
    },

    /**
     * Xét giá trị bảng tạm student được chọn
     * CreateBy: Nvduc 19.08
     */
    setSelectedStudentClassrooms (state, selectedStudentClassroom) {
      state.selectedStudentClassroom = selectedStudentClassroom
      // state.selectedStudentClassroom = [...state.listStudentExamPeriodFromApi]
    },

    /**
     * set lại dữ liệu
     * CreateBy: Nvduc 19.08
     */
    setExamPeriodClear (state) {
      state.examPeriod = {}
    },

    /**
     * set setExamPeriod
     * CreateBy: Nvduc 19.08
     */
    setExamPeriod (state, examPeriod) {
      state.examPeriod = examPeriod
    },

    // SetListStudent
    // CreateBy: VHSon 11.08
    setListStudent (state, listStudent) {
      state.listStudentExamPeriodFromApi = listStudent
    },

    /**
     * Gán giá trị cho list đề kiểm tra
     * @param {*} state
     * @param {*} examStores
     * CreateBy: Nvduc 15.08
     */
    setExamStores (state, examStores) {
      state.examStores = examStores || []
    },

    /**
     * Gán giá trị cho list lớp học
     * @param {*} state
     * @param {*} classRooms
     * CreateBy Nvduc 16.08
     */
    setClassRoom (state, classRooms) {
      state.classRooms = classRooms || []
    },

    /**
     * @description lấy state classroom
     * @author NTQuy
     * @param {*} state
     * @returns
     */
    getClassroom (state) {
      return state.classroom
    },

    /**
     * Giá trị trả ra khi cất
     * @param {*} state
     * @param {*} itemExam
     */
    setItemExam (state, itemExam) {
      state.itemExam = itemExam
    },

    /**
     * Giá trị trả ra khi cất
     * @param {*} data
     */
    setListExamPeriodOverview (state, data) {
      state.listExamPeriodOverview = data
    },

    /**
     * Gán giá trị cho list bài kiểm tra
     * @param {*} state
     * @param {*} listExams
     */
    setFilterExamPeriod (state, listExams) {
      state.listExams = listExams || []
    },

    /**
     * Gán giá trị cho list học sinh
     * @param {*} state
     * @param {*} studentClassrooms
     * stdclassroom: Bảng danh sách học sinh
     * studentExamPeriodFromApi: Bảng học sinh dk chọn trong lớp
     * selectedStudentClassroom: Bảng chọn những học sinh để update
     * CreateBy: Nvduc 20.08
     */
    setFilterStudentClassroom (state, studentClassrooms) {
      var objectName = {}
      studentClassrooms?.forEach((element) => {
        objectName = {
          studentFirstName: element?.StudentName?.split(' ')
            .slice(0, -1)
            .join(' '), // returns Họ và tên đệm
          studentLastName: element?.StudentName?.split(' ').slice(-1).join(' ') // returns tên
        }
        element = Object.assign(element, objectName)
      })
      studentClassrooms?.sort(function (a, b) {
        if (a.studentLastName.localeCompare(b.studentLastName) < 0) {
          return -1
        }
        if (a.studentLastName.localeCompare(b.studentLastName) > 0) {
          return 1
        }
        if (
          a.studentLastName.localeCompare(b.studentLastName) === 0 &&
          a.studentFirstName.localeCompare(b.studentFirstName) < 0
        ) {
          return -1
        }
        if (
          a.studentLastName.localeCompare(b.studentLastName) === 0 &&
          a.studentFirstName.localeCompare(b.studentFirstName) > 0
        ) {
          return 1
        }
        return 0
      })

      // Chỉnh sửa :
      // TH: Giao cho lớp
      if (state.examPeriod.AssignType === Enumeration.AssignType.ClassDelivery || state.examPeriod?.AssignType === undefined) {
        state.studentClassrooms = studentClassrooms
      }
      // TH: Giao cho HS
      if (state.examPeriod.AssignType === Enumeration.AssignType.ListStudentDelivery) {
        if (state.listStudentExamPeriodFromApi.length !== 0) {
          // Kiểm tra học sinh của 2 bảng
          const studentTerm = []
          studentClassrooms?.forEach(studentClassroom => {
            let isExit = true
            state.listStudentExamPeriodFromApi?.forEach(e => {
              if (e.StudentID === studentClassroom.StudentID && e.ClassCode === studentClassroom.ClassCode) {
                isExit = false
              }
            })
            if (isExit) { studentTerm.push(studentClassroom) }
          })
          state.studentClassrooms = studentTerm
          state.selectedStudentClassroom = state.listStudentExamPeriodFromApi
        } else {
          state.studentClassrooms = studentClassrooms
          state.selectedStudentClassroom = []
        }
      }
    },

    /**
     * Set giá trị khi lấy từng phần tử
     */
    setIdStudentClass (state, param) {
      if (param.isSelect) {
        const student = state.studentClassrooms[param.index]
        state.studentClassrooms.splice(param.index, 1)
        state.selectedStudentClassroom.push(student)
      } else {
        const student = state.selectedStudentClassroom[param.index]
        if (student.ClassCode === param.classCode) {
          state.selectedStudentClassroom.splice(param.index, 1)
          state.studentClassrooms.push(student)
        } else {
          state.selectedStudentClassroom.splice(param.index, 1)
        }
      }
    },

    /**
     * Lấy tất các phần tử
     * @param {*} state
     * @param {*} selectAll
     */
    setAllStudentClass (state, selectAll) {
      const studentClassrooms = state.studentClassrooms
      const selectedStudentClassroom = state.selectedStudentClassroom
      if (selectAll) {
        state.selectedStudentClassroom = [...studentClassrooms, ...selectedStudentClassroom]
        state.studentClassrooms = []
      } else {
        state.studentClassrooms = [...studentClassrooms, ...selectedStudentClassroom]
        state.selectedStudentClassroom = []
      }
    },
    /**
     * Gán giá trị response sau khi mở, đóng đề
     * @param {*} state
     * @param {*} updateStatusResponse
     */
    setUpdateStatusResponse (state, updateStatusResponse) {
      state.updateStatusResponse = updateStatusResponse
    },

    /**
     * @author PVThang
     * @description set giá trị cho totalTeacherExam
     */
    setTotalDoneTeacherExam (state, newVal) {
      state.totalDoneTeacherExam = newVal
    },
    /**
     * @author PVThang
     * @description set giá trị cho totalTeacherExam
     */
    setTotalNotDoneTeacherExam (state, newVal) {
      state.totalNotDoneTeacherExam = newVal
    },

    updateExamPeriodDetail (state, params) {
      state.examPeriodDetail.HaveResult = params.HaveResult
    },
    /**
     * Thông tin bài tập bài kiểm tra trộn câu hỏi
     * @param {*} state
     * @param {*} data
     */
    setShuffleExam (state, data) {
      state.shuffleExam = data
    },
    /**
     * set giá trị mã đề kiểm tra
     * @param {*} state
     * @param {*} data
     */
    setExamCodes (state, data) {
      state.examCodes = data
    },
    /**
     * set giá trị tổng số học sinh đã nộp
     * @param {*} state
     * @param {*} data
     */
    setStudentAmountSubmit (state, data) {
      state.studentAmountSubmit = data
    }
  },

  actions: {

    /**
     * Lấy thông tin Bài kiểm tra theo ID
     * @author VHSon
     * @param {*} examId
     * @param {*} context
     * @returns
     */
    getExamPeriodById (context, examId) {
      return new Promise((resolve, reject) => {
        TeacherExamPeriodAPI.getAsync(`/detail?id=${examId}`).then(res => {
          context.commit('setExam', res?.Data)
          resolve(res.Data)
        }
        ).catch(err => {
          reject(err)
        })
      })
    },

    /**
     * Lấy thông tin bài kiểm tra do hội đồng tổ chức theo ID
     * @param {*} context
     * @param {*} examId
     * @returns
     */
    getSchoolExamPeriodById (context, params) {
      return new Promise((resolve, reject) => {
        SchoolExamAssignAPI.getAsync('detail', { params: params })
          .then((res) => {
            context.commit('setExam', res?.Data)
            resolve(res.Data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Lấy danh sách học sinh theo ID bài kiểm tra
     * @author VHSon
     * @param {*} examId
     * @param {*} context
     * @returns
     */
    getlistStudentById (context, studentParams) {
      return new Promise((resolve, reject) => {
        TeacherExamPeriodAPI.getAsync(`/student-detail?id=${studentParams.examPeriodId}`).then(res => {
          context.commit('setListStudent', res?.Data)
          resolve(res.Data)
        }
        ).catch(err => {
          reject(err)
        })
      })
    },

    /**
     * Lấy danh sách học sinh theo ID bài kiểm tra do trường tổ chức
     * @param {*} context
     * @param {*} studentParams
     * @returns
     */
    getlistStudentBySchoolExamId (context, studentParams) {
      return new Promise((resolve, reject) => {
        SchoolExamPeriodDetailAPI.getAsync(
          `/student-detail?examPeriodDetailId=${studentParams.examPeriodId}` +
          `&classId=${studentParams.classId}`
        )
          .then(res => {
            context.commit('setListStudent', res?.Data)
            resolve(res.Data)
          }
          ).catch(err => {
            reject(err)
          })
      })
    },

    /**
     * Lấy danh sách học sinh theo ID bài kiểm tra
     * @author VHSon
     * @param {*} examId
     * @param {*} context
     * @param {*} filterType
     * @returns
     */
    refreshListStudent (context, studentParams) {
      return new Promise((resolve, reject) => {
        TeacherExamPeriodAPI.getAsync(`/refresh?id=${studentParams.examPeriodId}`).then(res => {
          context.commit('setListStudent', res?.Data)
          resolve(res.Data)
        }
        ).catch(err => {
          reject(err)
        })
      })
    },

    /**
     * Lấy danh sách học sinh theo ID bài kiểm tra
     * @author VHSon
     * @param {*} examId
     * @param {*} context
     * @param {*} filterType
     * @returns
     */
    refreshListStudentSchool (context, studentParams) {
      return new Promise((resolve, reject) => {
        SchoolExamPeriodDetailAPI.getAsync('refresh', { params: studentParams }).then(res => {
          context.commit('setListStudent', res?.Data)
          resolve(res.Data)
        }
        ).catch(err => {
          reject(err)
        })
      })
    },

    /**
     * Xóa bài tập
     * @author VHSon
     * @param {*} context
     * @param {*} examId
     * @returns
     */
    deleteExamPeriodByID (context, examId) {
      return new Promise((resolve, reject) => {
        TeacherExamPeriodAPI.deleteTeacherExamPeriod(examId).then(res => {
          resolve(res.Data)
        }).catch(err => {
          reject(err)
        })
      })
    },

    /**
     * Cập nhật trạng thái mở đóng đề
     * @author VHSon
     * @param {*} context
     * @param {*} examPeriodId
     * @param {*} Status
     * @returns
     */
    updateExamPeriodStatus (context, updateStatusParams) {
      return new Promise((resolve, reject) => {
        TeacherExamPeriodAPI.postAsync('update-status?id=' + updateStatusParams.Id + '&status=' + updateStatusParams.Status).then(res => {
          context.commit('setUpdateStatusResponse', res?.Data)
          resolve(res.Data)
        }
        ).catch(err => {
          reject(err)
        })
      })
    },

    /**
     * Cập nhật trạng thái mở đóng đề
     * @author VHSon
     * @param {*} context
     * @param {*} examPeriodId
     * @param {*} haveResult
     * @returns
     */
    updateExamPeriodHaveResult (context, updateHaveResultParams) {
      return new Promise((resolve, reject) => {
        TeacherExamPeriodAPI.postAsync('update-result?id=' + updateHaveResultParams.Id + '&haveResult=' + updateHaveResultParams.HaveResult).then(res => {
          resolve(res.Data)
        }
        ).catch(err => {
          reject(err)
        })
      })
    },

    /**
     * Gọi API lấy tất cả các đề kiểm tra
     * @param {*} context
     * @param {*} param
     * @returns
     * CreateBy Nvduc 15.08
     */
    getAllExamStore (context, param) {
      return new Promise((resolve, reject) => {
        ExamStoreAPI.getAsync(`filter?TypeExam=${param.typeExam}&Status=${param.status}&SubjectCode=${param.subjetCode}`)
          .then((res) => {
            context.commit('setExamStores', res?.Data?.PageData)
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Gọi API lấy tất cả các bài kiểm tra
     * @param {*} context
     * @returns
     * CreateBy: Nvduc 15.08
     */
    getFilterExamPeriod (context, params) {
      return new Promise((resolve, reject) => {
        TeacherExamPeriodAPI.getAsync('list', { params: params })
          .then((res) => {
            context.commit('setFilterExamPeriod',
              params.pageIndex === Pagination.PageIndexDefault
                ? res?.Data?.PageData
                : [...(context.state?.listExams || []), ...(res?.Data?.PageData || [])])
            context.commit('setTotalDoneTeacherExam', res?.Data?.TotalDone)
            context.commit('setTotalNotDoneTeacherExam', res?.Data?.TotalNotDone)

            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Gọi API lấy 3 bài kiểm tra màn hình tổng quan giáo viên vãng lai
     * @param {*} context
     * @returns
     * CreateBy: VHSON 17.03
     */
    getExamPeriodOverview (context, params) {
      return new Promise((resolve, reject) => {
        TeacherExamPeriodAPI.getAsync('top-overview')
          .then((res) => {
            context.commit('setListExamPeriodOverview', res.Data)
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Cất các bài kiểm tra
     * @param {*} context
     * @param {*} param
     * @returns
     * CreateBy Nvduc 15.08
     */
    insertTeacherExamPeriod (context, param) {
      return new Promise((resolve, reject) => {
        TeacherExamPeriodAPI.postAsync('create', param)
          .then((res) => {
            context.commit('setItemExam', res?.Data)
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    updateTeacherExamPeriod (context, param) {
      return new Promise((resolve, reject) => {
        TeacherExamPeriodAPI.postAsync('update', param)
          .then((res) => {
            context.commit('setItemExam', res?.Data)
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Filter học sinh theo lớp
     * @param {*} context
     * @param {*} value
     * @returns
     */
    getFilterStudentByClass (context, value) {
      const query =
          `classCode=${value}` +
          '&classID='
      return new Promise((resolve, reject) => {
        StudentClasroomAPI.getAsync(`students?${query}`)
          .then((res) => {
            context.commit('setFilterStudentClassroom', res?.Data)
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @author PVThang
     * @description đếm số lượng bản ghi của các tab
     * @param {*} context
     * @returns
     */
    async countExamPeriod (context, params) {
      return await TeacherExamPeriodAPI.getAsync(`count-exam-period?schoolYear=${params.schoolYear ? params.schoolYear : ''}`)
    },

    /**
     * Gửi điểm với bài kiểm tra do hội đồng tổ chức
     * @param {*} context
     * @param {*} params
     * @returns
     */
    async submitSchoolExam (context, params) {
      return new Promise((resolve, reject) => {
        SchoolExamAssignAPI.putAsync('submit-school', params)
          .then((res) => {
            resolve(res.Data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Gửi điểm với bài kiểm tra do hội đồng tổ chức
     * @param {*} context
     * @param {*} params
     * @returns
     */
    async updateIsRoundMark (context, params) {
      const query =
      `teacherExamPeriodId=${params.teacherExamPeriodId}` +
      `&isRoundMark=${params.isRoundMark}`
      return new Promise((resolve, reject) => {
        TeacherExamPeriodAPI.getAsync(`update-is-round-mark?${query}`)
          .then((res) => {
            resolve(res.Data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Gửi điểm với bài kiểm tra do hội đồng tổ chức
     * @param {*} context
     * @param {*} params
     * @returns
     */
    async updateRuleRoundMark (context, params) {
      const query =
      `teacherExamPeriodId=${params.teacherExamPeriodId}` +
      `&ruleRoundMark=${params.ruleRoundMark}`
      return new Promise((resolve, reject) => {
        TeacherExamPeriodAPI.getAsync(`update-rule-round-mark?${query}`)
          .then((res) => {
            resolve(res.Data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    /**
     * lấy thông tin đề kiểm tra
     * @param {*} context
     * @param {*} params
     * @returns
     */
    getShuffleExamStoreByTeacherExamAndSortOrderID (context, params) {
      return new Promise((resolve, reject) => {
        TeacherExamPeriodAPI.getAsync('shuffle-exam', { params: params })
          .then((res) => {
            context.commit('setShuffleExam', res?.Data)
            resolve(res.Data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    /**
     * Lấy mã đề kiểm tra
     * @param {*} context
     * @param {*} params
     * @returns
     */
    getExamCode (context, params) {
      return new Promise((resolve, reject) => {
        TeacherExamPeriodAPI.getAsync('exam-code', { params: params }).then((res) => {
          context.commit('setExamCodes', res.Data)
          resolve(res)
        })
          .catch((err) => {
            reject(err)
          })
      })
    }
  }
}
